"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = {
    class: "scc-modal eh-popup-panel",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "scc-title"
};
var _hoisted_2 = { class: "scc-header" };
var _hoisted_3 = { class: "scc-body" };
var _hoisted_4 = { class: "scc-add-row" };
var _hoisted_5 = ["disabled"];
var _hoisted_6 = ["maxlength", "disabled"];
var _hoisted_7 = ["disabled"];
var _hoisted_8 = { key: 0 };
var _hoisted_9 = { key: 1 };
var _hoisted_10 = ["disabled"];
var _hoisted_11 = {
    key: 1,
    class: "scc-error"
};
var _hoisted_12 = {
    key: 2,
    class: "scc-muted"
};
var _hoisted_13 = {
    key: 3,
    class: "scc-muted"
};
var _hoisted_14 = {
    key: 4,
    class: "scc-list"
};
var _hoisted_15 = { class: "scc-list-label" };
var _hoisted_16 = { class: "scc-list-meta" };
var _hoisted_17 = ["disabled", "onClick"];
var _hoisted_18 = {
    key: 5,
    class: "scc-error"
};
var vue_3 = require("vue");
var schedulingCustomizationApi_1 = require("@/api/schedulingCustomizationApi");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SchedulingContextCustomizationModal',
    props: {
        accountnumber: {},
        actorId: {},
        actorName: {}
    },
    emits: ["close"],
    setup: function (__props) {
        var props = __props;
        var LABEL_MAX = schedulingCustomizationApi_1.CUSTOM_CONTEXT_LABEL_MAX;
        var entries = (0, vue_3.ref)([]);
        var loading = (0, vue_3.ref)(true);
        var adding = (0, vue_3.ref)(false);
        var saving = (0, vue_3.ref)(false);
        var newLabel = (0, vue_3.ref)('');
        var formError = (0, vue_3.ref)('');
        var addInput = (0, vue_3.ref)(null);
        var deletingId = (0, vue_3.ref)(null);
        var deleteError = (0, vue_3.ref)('');
        function load() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            loading.value = true;
                            return [4 /*yield*/, (0, schedulingCustomizationApi_1.getCustomSchedulingContexts)({ accountnumber: props.accountnumber })];
                        case 1:
                            res = _a.sent();
                            entries.value = (res === null || res === void 0 ? void 0 : res.status) === 'Successful' && Array.isArray(res.data) ? res.data : [];
                            loading.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function openAdd() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            formError.value = '';
                            newLabel.value = '';
                            adding.value = true;
                            return [4 /*yield*/, (0, vue_3.nextTick)()];
                        case 1:
                            _b.sent();
                            (_a = addInput.value) === null || _a === void 0 ? void 0 : _a.focus();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function cancelAdd() {
            adding.value = false;
            newLabel.value = '';
            formError.value = '';
        }
        function save() {
            return __awaiter(this, void 0, void 0, function () {
                var label, res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            label = newLabel.value.trim();
                            if (!label)
                                return [2 /*return*/];
                            formError.value = '';
                            saving.value = true;
                            return [4 /*yield*/, (0, schedulingCustomizationApi_1.addCustomSchedulingContext)({
                                    accountnumber: props.accountnumber,
                                    actorId: props.actorId,
                                    actorName: props.actorName,
                                    label: label
                                })];
                        case 1:
                            res = _b.sent();
                            saving.value = false;
                            if (!((res === null || res === void 0 ? void 0 : res.status) === 'Successful')) return [3 /*break*/, 4];
                            // Repeatable add flow: clear + reopen the input immediately so an admin
                            // can enter another one right away, rather than re-clicking "+" each time.
                            return [4 /*yield*/, load()];
                        case 2:
                            // Repeatable add flow: clear + reopen the input immediately so an admin
                            // can enter another one right away, rather than re-clicking "+" each time.
                            _b.sent();
                            newLabel.value = '';
                            return [4 /*yield*/, (0, vue_3.nextTick)()];
                        case 3:
                            _b.sent();
                            (_a = addInput.value) === null || _a === void 0 ? void 0 : _a.focus();
                            return [3 /*break*/, 5];
                        case 4:
                            formError.value = (res === null || res === void 0 ? void 0 : res.message) || 'Could not save this context.';
                            _b.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        // Removing a context also removes it from the Visit Context dropdown in
        // Scheduling -> Appointments (SchedulingCalendar.vue loads the current list
        // fresh on every mount) — nothing else to clean up, see deleteCustomSchedulingContext's comment.
        function remove(entry) {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!confirm("Remove \"".concat(entry.label, "\"? It will no longer appear in the Visit Context dropdown.")))
                                return [2 /*return*/];
                            deleteError.value = '';
                            deletingId.value = entry.id;
                            return [4 /*yield*/, (0, schedulingCustomizationApi_1.deleteCustomSchedulingContext)({
                                    accountnumber: props.accountnumber,
                                    actorId: props.actorId,
                                    actorName: props.actorName,
                                    id: entry.id
                                })];
                        case 1:
                            res = _a.sent();
                            deletingId.value = null;
                            if ((res === null || res === void 0 ? void 0 : res.status) === 'Successful') {
                                entries.value = entries.value.filter(function (e) { return e.id !== entry.id; });
                            }
                            else {
                                deleteError.value = (res === null || res === void 0 ? void 0 : res.message) || 'Could not remove this context.';
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onMounted)(load);
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "scc-modal" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createElementVNode)("div", {
                            class: "scc-overlay eh-popup-overlay",
                            onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(function ($event) { return (_ctx.$emit('close')); }, ["self"]))
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", {
                                        class: "scc-header-spacer",
                                        "aria-hidden": "true"
                                    }, null, -1)),
                                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("h2", {
                                        id: "scc-title",
                                        class: "scc-title"
                                    }, "Scheduling Custom Context Entries", -1)),
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "scc-close",
                                        "aria-label": "Close",
                                        onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('close')); })
                                    }, "✕")
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                        _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", { class: "scc-add-label" }, "Add Custom Scheduling Context", -1)),
                                        (!adding.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                key: 0,
                                                type: "button",
                                                class: "scc-add-btn",
                                                disabled: loading.value,
                                                title: "Add a custom context",
                                                onClick: openAdd
                                            }, "+", 8, _hoisted_5))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]),
                                    (adding.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                                            key: 0,
                                            class: "scc-add-form",
                                            onSubmit: (0, vue_2.withModifiers)(save, ["prevent"])
                                        }, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                ref_key: "addInput",
                                                ref: addInput,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((newLabel).value = $event); }),
                                                type: "text",
                                                class: "scc-input",
                                                placeholder: "e.g. Dialysis Center Visit",
                                                maxlength: (0, vue_2.unref)(LABEL_MAX),
                                                disabled: saving.value
                                            }, null, 8, _hoisted_6), [
                                                [vue_2.vModelText, newLabel.value]
                                            ]),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "submit",
                                                class: "scc-icon-btn scc-save",
                                                title: "Save",
                                                disabled: saving.value || !newLabel.value.trim()
                                            }, [
                                                (saving.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_8, "…"))
                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_9, "✓"))
                                            ], 8, _hoisted_7),
                                            (0, vue_2.createElementVNode)("button", {
                                                type: "button",
                                                class: "scc-icon-btn scc-cancel",
                                                title: "Cancel",
                                                disabled: saving.value,
                                                onClick: cancelAdd
                                            }, "✕", 8, _hoisted_10)
                                        ], 32))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (formError.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_11, (0, vue_2.toDisplayString)(formError.value), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (loading.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_12, "Loading…"))
                                        : (!entries.value.length)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_13, " No custom contexts yet. Every entry added here is also appended to the Visit Context dropdown in Scheduling → Appointments. "))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_14, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(entries.value, function (entry) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                        key: entry.id,
                                                        class: "scc-list-item"
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(entry.label), 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(entry.created_by_name || '—'), 1),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: "scc-delete-btn",
                                                            title: "Remove this context",
                                                            disabled: deletingId.value === entry.id,
                                                            onClick: function ($event) { return (remove(entry)); }
                                                        }, "🗑", 8, _hoisted_17)
                                                    ]));
                                                }), 128))
                                            ])),
                                    (deleteError.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_18, (0, vue_2.toDisplayString)(deleteError.value), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ])
                        ])
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
